import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, Button, Icon, Tooltip, Logo, Shape } from 'elements';

import styles from './profileHeader.scss';

const ProfileHeader = ({ avatarSrc, name, username, isOwner, showTooltip, onClick }) => (
  <header className={styles.profileHeader}>
    <Shape color="gray" className={styles.shape} />
    <div className={styles.bin}>
      <div className={styles.userInfo}>
        <Avatar small className={styles.avatar} src={avatarSrc}/>
        <div className={styles.nametag}>
          <div className={styles.name}>{name}</div>
          <div className={styles.tag}>@{username}</div>
        </div>
      </div>
      {
        isOwner
        ?
          <Button
            primary
            round
            borderWeight="thick"
            size="Small"
            onClick={onClick}
          >
            <Icon name="icon-plus" />
          </Button>
        :
        <Logo gradient size="small" />
      }
    </div>
    {isOwner && showTooltip &&
      <Tooltip>
        Add your first link using the plus button
      </Tooltip>
    }
  </header>
);

ProfileHeader.propTypes = {
  avatarSrc: PropTypes.string,
  name: PropTypes.string,
  username: PropTypes.string,
  isOwnder: PropTypes.bool,
  showTooltip: PropTypes.bool,
  onClick: PropTypes.func,
};

export { ProfileHeader };



// WEBPACK FOOTER //
// ./src/components/header/profileHeader.js